import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { DataRow } from './data-section.model';
import { getAccentIconClasses, getAccentIconColor } from '../../../utils/accent-colors.utils';


@Component({
  selector: 'app-data-section',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './data-section.component.html',
})
export class DataSectionComponent {
  title = input('');
  icon = input('');
  accentColor = input<'primary' | 'success' | 'warning' | 'danger' | 'info' | 'violet'>('primary');
  rows = input<DataRow[]>([]);

  iconClasses = computed(() => getAccentIconClasses(this.accentColor()));
  iconColor = computed(() => getAccentIconColor(this.accentColor()));
}
